import { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterService } from './config/routing/RouterService';
import { initializePersistObject } from './shared/util/localStorageUtil';
import ErrorFallback from './common/ErrorFallback';

import './App.css';

initializePersistObject();

const App: FC = () => {
    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {
                // Reset app state if needed
                window.location.href = '/';
            }}
        >
            <RouterService />
        </ErrorBoundary>
    );
};

export default App;


